import { getProfileName, ObjectWithProfileName } from "PFCore/helpers/profile";
import { profileHash } from "PFCore/helpers/profile_hash";
import { Profile } from "PFCore/types";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

type UseUnbiasedProfileName = {
  getUnbiasedProfileName: (profile: Partial<ObjectWithProfileName>, isUnbiasedMode?: boolean) => string;
};

export const useUnbiasedProfileName = (): UseUnbiasedProfileName => {
  const { t } = useTranslation("core");

  const getUnbiasedProfileName = useCallback(
    (profile: Profile, isUnbiasedMode?: boolean) => {
      if (isUnbiasedMode) {
        return t("candidateHash", { profileHash: profileHash(profile.id) });
      }

      return getProfileName(profile);
    },
    [t]
  );

  return { getUnbiasedProfileName };
};
